import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { getApiUrl } from '#lib/utils/environment';
import { WithCustomerPortalApi } from '../../customerPortalApi';

type ValidationResponse = {
  valid: boolean;
};

export const useValidateMarking = WithCustomerPortalApi<
  ValidationResponse,
  UseMutationResult<ValidationResponse, undefined, { partnerId: string; marking: string }>,
  { partnerId: string; marking: string }
>(
  (fetchFn) =>
    useMutation<ValidationResponse, undefined, { partnerId: string; marking: string }>({
      mutationFn: async ({ partnerId, marking }) => {
        try {
          return await fetchFn({
            url: `${getApiUrl()}/v2/partners/${partnerId}/request-new-location/validate`,
            options: {
              method: 'POST',
              body: JSON.stringify({ marking }),
            },
          });
        } catch (error) {
          throw new Error('Failed to validate marking', { cause: error });
        }
      },
    }),
  { hookName: 'useValidateMarking' },
);
